import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noAccessOnIssueCreatedWarning: {
		id: 'issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning',
		defaultMessage: "Select the roles that you're a part of to avoid losing access to this issue.",
		description:
			'Warning message to be shown when user is restricting issue to roles he has no access to',
	},
	noAccessOnIssueCreatedWarningIssueTermRefresh: {
		id: 'issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning-issue-term-refresh',
		defaultMessage:
			"Select the roles that you're a part of to avoid losing access to this work item.",
		description:
			'Warning message to be shown when user is restricting issue to roles he has no access to',
	},
});
